angular.module('wbDirectives').directive 'wbOutOfBounds', ->
  restrict: 'A'
  scope: { wbOutOfBounds: '=' }
  link: ($scope, $el, $attrs) ->
    maxDistanceToEdge = 5

    checkBounds = ->
      return unless $el.is(':visible')
      $el.removeClass('out-of-bounds')
      distanceFromRight = window.innerWidth - ($el.offset().left + $el.outerWidth())
      distanceFromLeft = $el.offset().left

      if distanceFromRight < maxDistanceToEdge || distanceFromLeft < maxDistanceToEdge
        $el.addClass('out-of-bounds')

    window.addEventListener 'resize', _.debounce(checkBounds, 500)

    $scope.$watch 'wbOutOfBounds', _.debounce(checkBounds, 500)
